import { MapScreen } from "@/src/screens/map-screen";

export default function MapRoute() {
  return <MapScreen />;
}
